class ShippingModule extends HTMLElement {
  constructor() {
    super();
  }

  refresh() {
    fetch(window.Shopify.routes.root + "?section_id=async-cart-shipping-module")
    .then(res => res.text())
    .then(txt => {
      let markup = new DOMParser().parseFromString(txt, "text/html").querySelector(".async-cart-shipping-module");
      this.innerHTML = markup.innerHTML;
    });
  }
}

customElements.define("shipping-module", ShippingModule);